(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-reviews-carousel';

  function initSection(section) {
    if (!section || section.dataset.odditCarouselReady === 'true') return;
    section.dataset.odditCarouselReady = 'true';

    var track = section.querySelector('.oddit-section-reviews-carousel__track');
    var slides = section.querySelectorAll('.oddit-section-reviews-carousel__slide');
    var dotsContainer = section.querySelector('.oddit-section-reviews-carousel__dots');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');

    if (!track || !slides.length) return;

    var dotTargets = [];

    function getStep() {
      // Distance to advance per arrow click = first slide width + flex gap.
      if (slides.length < 2) {
        return slides[0] ? slides[0].getBoundingClientRect().width : 0;
      }
      var first = slides[0].getBoundingClientRect();
      var second = slides[1].getBoundingClientRect();
      return Math.max(0, second.left - first.left);
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function computeDotTargets() {
      var step = getStep();
      var max = getMaxScroll();
      var targets = [0];
      if (step > 0 && max > 0) {
        // Each subsequent dot advances one slide-step until we cover max.
        // Cap the count at the slide count so we never produce more dots
        // than there are slides.
        var pos = step;
        while (pos < max && targets.length < slides.length - 1) {
          targets.push(pos);
          pos += step;
        }
        targets.push(max);
      }
      return targets;
    }

    function rebuildDots() {
      if (!dotsContainer) return;
      dotTargets = computeDotTargets();

      // Hide the dots row entirely when the carousel can't scroll
      if (dotTargets.length <= 1) {
        dotsContainer.innerHTML = '';
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';

      // Reuse existing dot buttons where possible to avoid event-listener churn
      while (dotsContainer.children.length > dotTargets.length) {
        dotsContainer.removeChild(dotsContainer.lastElementChild);
      }
      while (dotsContainer.children.length < dotTargets.length) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oddit-section-reviews-carousel__dot';
        dot.setAttribute('data-carousel-dot', '');
        dot.setAttribute('aria-selected', 'false');
        var idx = dotsContainer.children.length;
        dot.addEventListener('click', (function (capturedIndex) {
          return function () { scrollToDotIndex(capturedIndex); };
        })(idx));
        dotsContainer.appendChild(dot);
      }

      for (var i = 0; i < dotsContainer.children.length; i++) {
        var btn = dotsContainer.children[i];
        btn.setAttribute('data-slide-index', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      }

      updateDots();
    }

    function updateArrowState() {
      var max = getMaxScroll();
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('[data-carousel-dot]');
      if (!dots.length || !dotTargets.length) return;

      // Active dot = closest target to the current scroll position
      var current = track.scrollLeft;
      var activeIndex = 0;
      var closestDist = Infinity;
      for (var i = 0; i < dotTargets.length; i++) {
        var dist = Math.abs(current - dotTargets[i]);
        if (dist < closestDist) {
          closestDist = dist;
          activeIndex = i;
        }
      }

      for (var j = 0; j < dots.length; j++) {
        var isActive = j === activeIndex;
        dots[j].classList.toggle('oddit-section-reviews-carousel__dot--active', isActive);
        dots[j].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function scrollByStep(direction) {
      var step = getStep();
      if (!step) return;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    function scrollToDotIndex(index) {
      if (index < 0 || index >= dotTargets.length) return;
      track.scrollTo({ left: dotTargets[index], behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        updateArrowState();
        updateDots();
      },
      { passive: true }
    );

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        rebuildDots();
        updateArrowState();
      });
      ro.observe(track);
    } else {
      window.addEventListener('resize', function () {
        rebuildDots();
        updateArrowState();
      });
    }

    // Initial sync after layout settles
    requestAnimationFrame(function () {
      rebuildDots();
      updateArrowState();
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
